import styled from 'styled-components/macro'

export const ChartWrapper = styled.div`
  border: 1px solid #d5d6f4;
  border-radius: 10px;
  width: 100% !important;
`
